import React, { useState } from 'react';
import { Button, message } from 'antd';
import { AudioOutlined, LoadingOutlined } from '@ant-design/icons';
import { speechToText } from '../services/api';

interface VoiceInputProps {
  onResult: (text: string) => void;
}

const VoiceInput: React.FC<VoiceInputProps> = ({ onResult }) => {
  const [isRecording, setIsRecording] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [mediaRecorder, setMediaRecorder] = useState<MediaRecorder | null>(null);

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      
      // 指定MP3格式
      const options = { mimeType: 'audio/mpeg' };
      
      // 如果浏览器不支持MP3格式，则使用默认格式
      const recorder = MediaRecorder.isTypeSupported('audio/mpeg')
        ? new MediaRecorder(stream, options)
        : new MediaRecorder(stream);
      
      const audioChunks: Blob[] = [];

      recorder.ondataavailable = (event) => {
        audioChunks.push(event.data);
      };

      recorder.onstop = async () => {
        // 将音频片段合并为一个MP3文件
        const audioBlob = new Blob(audioChunks, { type: 'audio/mpeg' });
        
        setIsProcessing(true);
        
        try {
          // 创建一个包含时间戳的文件名
          const timestamp = Date.now();
          const fileName = `audio_${timestamp}.mp3`;
          
          // 创建File对象，设置文件名
          const audioFile = new File([audioBlob], fileName, { type: 'audio/mpeg' });
          
          // 调用API上传音频文件
          const result = await speechToText(audioFile);
          
          // 将识别结果传递给父组件
          if (result && result.text) {
            onResult(result.text);
            message.success('语音识别完成');
            console.log('识别结果:', result.text);
            console.log('文件路径:', result.filePath);
          } else {
            message.warning('未能识别语音内容');
          }
          
        } catch (error) {
          message.error('语音识别失败，请重试');
          console.error('Speech recognition error:', error);
        } finally {
          setIsProcessing(false);
          setIsRecording(false);
        }
      };

      // 每1秒生成一个数据块
      recorder.start(1000);
      setMediaRecorder(recorder);
      setIsRecording(true);
      message.info('开始录音...');
    } catch (error) {
      message.error('无法访问麦克风');
      console.error('Error accessing microphone:', error);
    }
  };

  const stopRecording = () => {
    if (mediaRecorder && mediaRecorder.state !== 'inactive') {
      mediaRecorder.stop();
      mediaRecorder.stream.getTracks().forEach(track => track.stop());
      message.info('录音结束，正在识别...');
    }
  };

  const buttonIcon = isProcessing ? <LoadingOutlined /> : 
                    isRecording ? <LoadingOutlined spin /> : 
                    <AudioOutlined />;

  const buttonText = isProcessing ? '正在识别...' :
                    isRecording ? '停止录音' :
                    '语音输入';

  return (
    <Button
      icon={buttonIcon}
      onClick={isRecording ? stopRecording : startRecording}
      danger={isRecording}
      loading={isProcessing}
      style={{ width: 150 }}
    >
      {buttonText}
    </Button>
  );
};

export default VoiceInput; 